// tslint:disable:ordered-imports - the order of the css includes is significant
import "@progress/kendo-ui/css/web/kendo.common-bootstrap.css";
import "@progress/kendo-ui/css/web/kendo.bootstrap.css";
import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.css";
import "../style/all.css";
// tslint:enable:ordered-imports

// Some polyfills for IE11
import * as promisePolyfill from "es6-promise";
promisePolyfill.polyfill();

// importing jquery and moment here in order to get exposer-loader to put them on the window object
import "jquery";
import "moment";

import {Application} from "./common/application";
import * as Global from "./common/global";
import * as KnockoutBindingHandlers from "./common/knockoutBindingHandlers";
import {IApplication} from "./interfaces/application";

// Include the web.config file so it gets added to /dest directory for IIS deployment
import "../web.config";

KnockoutBindingHandlers.registerKnockoutBindingHandlers();

// Globally set up jquery ajax calls to allow passing credentials
$.ajaxSetup({
  xhrFields: {
    withCredentials: true,
  },
});

const app: IApplication = new Application();
Global.storeAppSingleton(app);
Global.app().init().done((): void => {
    $("div[data-id='siteWaitContainer']").hide();
});

// This code is used to receive messages when OnCue is hosted inside of an iframe
function receiveMessage(event: MessageEvent) {
  // TODO - may want to add an origin check
  // if (event.origin !== "http://example.com:8080") return;
  if (event.data === "save") {
    app.pageManager().saveCurrentPage();
  }
}

window.addEventListener("message", receiveMessage, false);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/app.ts